module.exports = __webpack_public_path__ + "img/shape_1_08.1cc98718.png";